import { useCallback } from "react";
import { pluralizeWithCount } from "@common/helpers/string";
import { useEntities } from "@hooks/useEntities";

// Falls back to `Business {id}` when the entity has no name, the same
// fallback the editor uses.
export const useBusinessNamesFor = (): ((entityIds: number[]) => string[]) => {
    const businessEntities = useEntities({ onlyBusiness: true });
    return useCallback(
        (entityIds: number[]): string[] => {
            const byId = new Map(
                businessEntities.map((entity) => [entity.id, entity]),
            );
            return entityIds.map(
                (entityId) =>
                    byId.get(entityId)?.name ?? `Business ${entityId}`,
            );
        },
        [businessEntities],
    );
};

export const businessReachClause = (businessNames: string[]): string =>
    `${pluralizeWithCount("business", businessNames.length)}: ${businessNames.join(", ")}`;
